import React from "react";
import Layout from "src/components/Layout";
import "./OnsiteAssessment.css";
import image from "../../images/6.png";
import InfoCard from "src/components/InfoCard";

const OnsiteAssessment: React.FC = () => {
  return (
    <Layout>
      <InfoCard title={"Onsite Assessment"} image={image}>
        <div className="onsite-details">
          <p>
            It provides a convenient way to assess an employee’s fitness for
            work, physical health, overall wellbeing, and lifestyle choices.
            <br></br>
            For groups of employees, departments, or time-pressured staff,
            they’re ideal for informing both employee and employer about
            potential health concerns and fitness for work.
          </p>
          <p>
            <strong></strong>• Egypt-Wide Provision: Access dependable employee
            health assessments regardless of location, anywhere in Egypt.
            <br></br>
            <br></br>• Full Assessment Service: Rely on our full range of
            comprehensive onsite health screening services regardless of the
            site location.<br></br>
            <br></br>• Experienced Personnel: Benefit from the expertise of our
            Health Professionals who are fully qualified to provide advanced
            assessments and guidance.<br></br>
            <br></br>• Booking Simplicity: Streamline the appointment process
            with our specialized booking system which can be branded to your
            company’s requirements.<br></br>
            <br></br>• Convenient Assessments: Enjoy the advantages of onsite
            health checks in your own workplace. Avoid extra costs and the
            inconvenience of travel.<br></br>
            <br></br>• Wellbeing Strategy Integration: Combine onsite health
            screening with existing wellbeing policies. Make screening part of
            staff health-awareness events.<br></br>
            <br></br>• Barrier-Free Testing: Maximize health-check attendance
            and take-up. Enhanced visibility and ease of access to onsite health
            screening boosts participation.<br></br>
            <br></br>• Flexible Coverage: Adapt our core packages to meet the
            specific needs of your workforce. Our approach to .
          </p>
        </div>
      </InfoCard>
    </Layout>
  );
};

export default OnsiteAssessment;
